import API from '../../common/api';
import type { State } from '../reducers';
import { Action as ReduxAction, Dispatch } from 'redux';
import { Api } from '../../common/model';
import { ThunkDispatch } from 'redux-thunk';
import { ValidateActionMap } from '../../../shared/modules/redux/model';

type AppThunkDispatch = ThunkDispatch<State, unknown, Action>;

export namespace Action {
  export enum Type {
    CLEAR_DEPARTURE_SLOTS = 'CLEAR_DEPARTURE_SLOTS',
    FETCH_DEPARTURE_SLOTS = 'FETCH_DEPARTURE_SLOTS',
    FETCH_DEPARTURE_SLOTS_SUCCESS = 'FETCH_DEPARTURE_SLOTS_SUCCESS',
    CLEAR_ARRIVAL_SLOTS = 'CLEAR_ARRIVAL_SLOTS',
    FETCH_ARRIVAL_SLOTS = 'FETCH_ARRIVAL_SLOTS',
    FETCH_ARRIVAL_SLOTS_SUCCESS = 'FETCH_ARRIVAL_SLOTS_SUCCESS',
    ARRIVAL_SLOT_AVAILABLE = 'ARRIVAL_SLOT_AVAILABLE',
    ARRIVAL_SLOT_UNAVAILABLE = 'ARRIVAL_SLOT_UNAVAILABLE',
  }

  export interface FetchArrivalSlotsSuccessAction extends ReduxAction<Type.FETCH_ARRIVAL_SLOTS_SUCCESS> {
    slots: Api.SiteSlots;
  }

  export interface FetchDepartureSlotsSuccessAction extends ReduxAction<Type.FETCH_DEPARTURE_SLOTS_SUCCESS> {
    slots: Api.SiteSlots;
  }
}

export type Action<T extends Action.Type = Action.Type> = ValidateActionMap<{
  [Action.Type.FETCH_DEPARTURE_SLOTS]: ReduxAction<Action.Type.FETCH_DEPARTURE_SLOTS>;
  [Action.Type.FETCH_ARRIVAL_SLOTS]: ReduxAction<Action.Type.FETCH_ARRIVAL_SLOTS>;
  [Action.Type.CLEAR_ARRIVAL_SLOTS]: ReduxAction<Action.Type.CLEAR_ARRIVAL_SLOTS>;
  [Action.Type.FETCH_ARRIVAL_SLOTS_SUCCESS]: Action.FetchArrivalSlotsSuccessAction;
  [Action.Type.FETCH_DEPARTURE_SLOTS_SUCCESS]: Action.FetchDepartureSlotsSuccessAction;
  [Action.Type.ARRIVAL_SLOT_AVAILABLE]: ReduxAction<Action.Type.ARRIVAL_SLOT_AVAILABLE>;
  [Action.Type.ARRIVAL_SLOT_UNAVAILABLE]: ReduxAction<Action.Type.ARRIVAL_SLOT_UNAVAILABLE>;
  [Action.Type.CLEAR_DEPARTURE_SLOTS]: ReduxAction<Action.Type.CLEAR_DEPARTURE_SLOTS>;
}>[T];

export const clearDepartureSlots = (): Action<Action.Type.CLEAR_DEPARTURE_SLOTS> => ({
  type: Action.Type.CLEAR_DEPARTURE_SLOTS,
});

const fetchDepartureSlotsSuccess = (slots: Api.SiteSlots): Action<Action.Type.FETCH_DEPARTURE_SLOTS_SUCCESS> => ({
  type: Action.Type.FETCH_DEPARTURE_SLOTS_SUCCESS,
  slots,
});

const fetchArrivalSlotsSuccess = (slots: Api.SiteSlots): Action<Action.Type.FETCH_ARRIVAL_SLOTS_SUCCESS> => ({
  type: Action.Type.FETCH_ARRIVAL_SLOTS_SUCCESS,
  slots,
});

export const fetchDepartureSlots = (site: string, date: Date) => (dispatch: Dispatch<Action>) => {
  dispatch({ type: Action.Type.FETCH_DEPARTURE_SLOTS });

  API.getSiteDepartureSlots(site, date).then(slots => dispatch(fetchDepartureSlotsSuccess(slots)));
};

export const fetchArrivalSlots = (site: string, date: Date) => (dispatch: Dispatch<Action>) => {
  dispatch({ type: Action.Type.FETCH_ARRIVAL_SLOTS });

  API.getSiteArrivalSlots(site, date).then(slots => dispatch(fetchArrivalSlotsSuccess(slots)));
};

export const fetchSlotsOnBoot = () => (dispatch: AppThunkDispatch, getState: () => State) => {
  const { departure, arrival } = getState().booking;
  if (departure.site && departure.date) dispatch(fetchDepartureSlots(departure.site, departure.date));

  if (arrival.site && arrival.date) dispatch(fetchArrivalSlots(arrival.site, arrival.date));
};

export const clearArrivalSlots = (): Action<Action.Type.CLEAR_ARRIVAL_SLOTS> => ({
  type: Action.Type.CLEAR_ARRIVAL_SLOTS,
});

export const setArrivalSlotAvailable = (): Action<Action.Type.ARRIVAL_SLOT_AVAILABLE> => ({
  type: Action.Type.ARRIVAL_SLOT_AVAILABLE,
});

export const setArrivalSlotUnAvailable = (): Action<Action.Type.ARRIVAL_SLOT_UNAVAILABLE> => ({
  type: Action.Type.ARRIVAL_SLOT_UNAVAILABLE,
});
